const SigmoidFunction = () => {
    return (
        <div className="max-w-4xl mx-auto px-4">
            <p className="tw-header">Sigmoid Function</p>
        </div>
    )
}

export default SigmoidFunction;